import { signal } from 'services/SignalsService'
import { rules } from 'settings/buttons'
import { noop } from 'utils/Mocks'

const states = {}

function dispatch(id, payload) {
  const action = states[id] == false ? noop : signal.dispatch
  action(id, payload)
}

function makeHandler(name, state) {
  return function () {
    states[name] = state
  }
}

function init() {
  Object.entries(rules).forEach(([button, state]) => {
    state.disable.map((sig) => signal.on(sig, makeHandler(button, false)))
    state.enable.map((sig) => signal.on(sig, makeHandler(button, true)))
  })
}

export const ButtonManager = {
  init,
  dispatch,
}
